import React, { RefObject, useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CircleCheckIcon } from 'lucide-react';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
type FloatingCtaProps = {
  anchorRef: RefObject<HTMLDivElement>;
};
export function FloatingCta({
  anchorRef
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = anchorRef.current;
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, [anchorRef]);
  return <AnimatePresence data-id="element-37" data-mp="bqiwvq2qi8uu">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="pointer-events-none fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-2" data-id="element-38" data-mp="195wvbl25i5dn">
          <a href={CHECKOUT_URL} onClick={trackCheckout} className="pointer-events-auto mx-auto flex w-full max-w-lg animate-shake items-center justify-center gap-2.5 rounded-2xl bg-cta px-4 py-4 text-center text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_14px_30px_-8px_rgba(0,0,0,0.45)] ring-2 ring-white hover:bg-cta-dark sm:text-lg" data-id="element-39" data-mp="2f3iz31kjlvbx">
            <CircleCheckIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-40" data-mp="1weugim9j823b" />
            <span data-id="element-41" data-mp="1if33oour4rqw">Get it now for only $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}